import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../features/credit/model/index.js";
import "@perxis-auto/credit-sdk";
import "@perxis-auto/shared";
import "@perxis-auto/credit-sdk/lib/internal/entities/credit/lib/formatFinancialPrograms";
import { useCreditPreviewProgramPayment } from "../../../features/credit/lib/useCreditPreviewProgramPayment.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { formatPrice } from "../../../shared/lib/format/formatPrice.js";
import "../../../shared/lib/logger/index.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  var _a;
  const {
    label,
    value: customPayment,
    prefix,
    postfix,
    ...props
  } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const creditProgramPayment = useCreditPreviewProgramPayment(vehicleItem == null ? void 0 : vehicleItem.id);
  const payment = customPayment ?? creditProgramPayment;
  const formattedPayment = useMemo(() => {
    const resolvedPayment = payment ? `${Math.round(Number(payment))}/${t("common.month")}` : "";
    return formatPrice(resolvedPayment, prefix, postfix);
  }, [payment, t, prefix, postfix]);
  const credit = useMemo(
    () => {
      var _a2;
      return {
        model: (_a2 = vehicleItem == null ? void 0 : vehicleItem.data.model) == null ? void 0 : _a2.slug,
        price: vehicleItem == null ? void 0 : vehicleItem.data.minPrice,
        vehicleId: vehicleItem == null ? void 0 : vehicleItem.id
      };
    },
    [vehicleItem == null ? void 0 : vehicleItem.data.minPrice, (_a = vehicleItem == null ? void 0 : vehicleItem.data.model) == null ? void 0 : _a.slug, vehicleItem == null ? void 0 : vehicleItem.id]
  );
  return {
    ...props,
    credit,
    label,
    value: formattedPayment,
    isLoading
  };
};
export {
  useContainer
};
